import { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext } from 'commons-ui';

import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../utils/formConfig';

import { dehydrateFormDataForEdit } from '../../utils/formDataParser';
import useService from '../../utils/useService';

const useEdit = () => {
	const { showAlert } = useContext(AppContext);
	const [showLoader, setShowLoader] = useState(false);
	const { getManagerOptions, requestUpdateInternalUser } = useService();
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.managerName].setRenderProps({ getOptions: getManagerOptions });
	const history = useHistory();
	const location = useLocation();
	const data = _get(location, ['state', 'rowData']);
	const updateInternalUser = async (updatedData: any) => {
		setShowLoader(true);
		const response = await requestUpdateInternalUser(updatedData);
		if (response.data.success) {
			showAlert(`UserType updated successfully`, { type: 'success' });
			history.goBack();
		} else {
			showAlert(`Failed to edit userType: ${response.data.message || 'Unknown error'}`, { type: 'error' });
			history.goBack();
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		updateInternalUser(dehydrateFormDataForEdit(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useEdit;
